import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAccountId } from '../../utils/helpers';
import { setDefaultPaymentMethod, fetchZuoraSignature } from '../../modules/billing/actions';
import { selectCustomerData } from '../../modules/customer/selectors';
import { makeSelectSetDefautPaymentMethodFinished, makeSelectZuoraSignature } from '../../modules/billing/selectors';
import { selectErrors } from '../../modules/global/selectors';
import PropTypes from 'prop-types';
import { Error } from '../../components/Error';
import CreditCardInfoPageContent from './CreditCardInfoPageContent';
import _ from 'lodash';
import { ApiRequest } from '../../utils/api';
import { hideSpinner, showSpinner } from '../../modules/global/actions';
import { createErrorLogObject, FailedAction } from '../../utils/error';

const pageIdTest = '2c92c0f85388c41e0153894707f146cf';
const pageIdProd = '2c92a0ff53ef77b10153f0340b9550f1';
const pageIdLocal = '2c92c0f96ae86023016ae9d515a55866';
const zuoraUrlTest = 'https://apisandbox.zuora.com/apps/PublicHostedPageLite.do';
const zuoraUrlProd = 'https://www.zuora.com/apps/PublicHostedPageLite.do';

const LOCAL_ENV = window.location.host.indexOf('localhost') === 0;
const TEST_ENV = LOCAL_ENV ? true : window.location.host.indexOf('test.mobileoperator') >= 0;
const zuoraUrl = TEST_ENV ? zuoraUrlTest : zuoraUrlProd;
// eslint-disable-next-line
const pageId = LOCAL_ENV ? pageIdLocal : TEST_ENV ? pageIdTest : pageIdProd;

class CreditCardInFoPage extends React.PureComponent {
	state = {
		creditCardSubmitFinished: false,
		creditCardUpdateSuccessful: false
	};

	componentDidMount() {
		this.getZuoraSignatureObject();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.zuoraSignature) {
			this.renderZuoraIframe(nextProps.zuoraSignature);
		}
	}

	getZuoraSignatureObject = () => {
		const { doFetchZuoraSignature } = this.props;
		doFetchZuoraSignature(pageId, zuoraUrl);
	};

	sendErrorLog = (errorData) => {
		this.props.doShowSpinner();
		ApiRequest.logError(errorData)
			.execute()
			.then((response) => {
				this.props.doHideSpinner();
			})
			.catch((error) => {
				// Error modal is not opened for this error, just silently fail sending error
				this.props.doHideSpinner();
			});
	};

	handleZuoraResponse = (response) => {
		if (!_.isNil(response) && !_.isNil(response.refId)) {
			const paymentMethodId = response.refId;
			this.setState({
				creditCardUpdateSuccessful: true
			});
			this.props.doSetDefaultPaymentMethod(getAccountId(), paymentMethodId);
		} else {
			this.setState({
				creditCardUpdateSuccessful: false
			});
			const data = _.isNil(response) ? response : { ...response };
			const shortError = _.isNil(response) ? 'Zuora response was null' : 'Payment method id came as null from Zuora';
			this.sendErrorLog([createErrorLogObject('/account/creditCardInformation', FailedAction.FAILED_ACTION_CARD_CHANGE, shortError, 'Zuora response', data)]);
		}
		this.setState({
			creditCardSubmitFinished: true
		});
	};

	renderZuoraIframe = (zuoraSignatureObject) => {
		const { customerData } = this.props;
		const zuoraId = customerData.toJS().zuoraAccountId;
		const params = {
			url: zuoraUrl,
			tenantId: zuoraSignatureObject.tenantId,
			id: pageId,
			key: zuoraSignatureObject.key,
			token: zuoraSignatureObject.token,
			signature: zuoraSignatureObject.signature,
			submitEnabled: true,
			field_accountId: zuoraId,
			locale: 'fi',
			style: 'inline'
		};
		// eslint-disable-next-line
		Z.render(params, {}, this.handleZuoraResponse);
	};

	render() {
		const { errors } = this.props;
		const noErrors = errors && errors.length === 0;
		return (
			<div>
				{noErrors && <CreditCardInfoPageContent {...this.state} {...this.props} />}
				{this.state.creditCardSubmitFinished && (!this.state.creditCardUpdateSuccessful || !noErrors) && (
					<Error
						message={
							'Maksukortin päivitys epäonnistui. Mun Moissa on tällä hetkellä joidenkin asiakastilien kohdalla ongelmia maksukortin vaihdossa. Olethan asiakaspalveluumme yhteydessä jos nykyinen korttisi on vanhentumassa.'
						}
					/>
				)}
				{!noErrors && !this.state.creditCardSubmitFinished && <Error message={'Jotain meni vikaan. Yritä myöhemmin uudestaan tai ota yhteyttä asiakaspalveluumme'} />}
			</div>
		);
	}
}

CreditCardInFoPage.propTypes = {
	customerData: PropTypes.object,
	doSetDefaultPaymentMethod: PropTypes.func,
	doFetchZuoraSignature: PropTypes.func,
	errors: PropTypes.array,
	offeringType: PropTypes.string,
	doShowSpinner: PropTypes.func,
	doHideSpinner: PropTypes.func
};

const mapStateToProps = createStructuredSelector({
	customerData: selectCustomerData,
	errors: selectErrors,
	setDefaultPaymentMethodFinished: makeSelectSetDefautPaymentMethodFinished(),
	zuoraSignature: makeSelectZuoraSignature()
});

const mapDispathcToProps = (dispatch) => ({
	doFetchZuoraSignature: (pageIdParam, zuoraUrlParam) => dispatch(fetchZuoraSignature(pageIdParam, zuoraUrlParam)),
	doSetDefaultPaymentMethod: (accountId, paymentMethodId) => dispatch(setDefaultPaymentMethod(accountId, paymentMethodId)),
	doShowSpinner: () => dispatch(showSpinner()),
	doHideSpinner: () => dispatch(hideSpinner())
});

export default connect(mapStateToProps, mapDispathcToProps)(CreditCardInFoPage);
